var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M85.979,128H29.98c-3.309,0-6-2.664-6-5.938V5.936c0-3.273,2.691-5.936,6-5.936h55.998 c3.309,0,6,2.663,6,5.936l0.041,15.338l-4,0.011L87.979,5.941c0-1.073-0.897-1.941-2-1.941H29.98c-1.104,0-2,0.869-2,1.936 v116.127c0,1.068,0.896,1.938,2,1.938h55.998c1.103,0,2-0.869,2-1.938V84.258h4v37.805C91.979,125.336,89.287,128,85.979,128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.373,
    y: 106.287,
    fill: "#282D33",
    width: 63.218,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.373,
    y: 16.729,
    fill: "#282D33",
    width: 63.218,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 47.289,
    y: 8.793,
    fill: "#282D33",
    width: 21.382,
    height: 4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.369,
    y: 113.734,
    fill: "#282D33",
    width: 5.223,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M55.293,95.277V79.242h-4.739c-3.021,0-5.479-2.541-5.479-5.666V31.934c0-3.125,2.458-5.668,5.479-5.668 h47.981c3.024,0,5.484,2.542,5.484,5.668v41.643c0,3.125-2.46,5.666-5.484,5.666H74.527L55.293,95.277z M50.554,30.266 c-0.815,0-1.479,0.748-1.479,1.668v41.643c0,0.918,0.663,1.666,1.479,1.666h8.739v11.492l13.785-11.492h25.457 c0.818,0,1.484-0.748,1.484-1.666V31.934c0-0.92-0.666-1.668-1.484-1.668H50.554z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M63.439,52.687c-4.733,0-8.584-3.803-8.584-8.477s3.851-8.477,8.584-8.477s8.584,3.803,8.584,8.477 S68.173,52.687,63.439,52.687z M63.439,39.732c-2.528,0-4.584,2.008-4.584,4.477s2.056,4.477,4.584,4.477 c2.527,0,4.584-2.008,4.584-4.477S65.967,39.732,63.439,39.732z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M84.632,70.215c-4.731,0-8.58-3.803-8.58-8.477c0-4.675,3.849-8.479,8.58-8.479 c4.733,0,8.585,3.804,8.585,8.479C93.217,66.412,89.365,70.215,84.632,70.215z M84.632,57.259c-2.525,0-4.58,2.009-4.58,4.479 c0,2.469,2.055,4.477,4.58,4.477c2.528,0,4.585-2.008,4.585-4.476C89.217,59.269,87.16,57.259,84.632,57.259z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 72.227,
    y: 30.936,
    transform: "matrix(0.7013 0.7128 -0.7128 0.7013 60.0651 -37.0331)",
    fill: "#282D33",
    width: 4,
    height: 44.457
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.0a7d2976b26633ba3704950a9892afce.svg";
export { ForwardRef as ReactComponent };